import React from "react";
import { Badge } from "react-bootstrap";

import { GameFeaturingLaunchState, useChoiceLabel } from "@/const";

export const getColorByState = (state) => {
    switch (state) {
        case GameFeaturingLaunchState.DRAFT:
            return "#6c757d";
        case GameFeaturingLaunchState.REVIEW_PASSED:
            return "#28a745";
        case GameFeaturingLaunchState.REJECTED:
            return "#dc3545";
        case GameFeaturingLaunchState.REFUSED:
            return "#dc3545";
        case GameFeaturingLaunchState.MARKETING_REVIEW:
            return "#ffc107";
        case GameFeaturingLaunchState.PROMO_LAUNCHED:
            return "#007bff";
        default:
            return "#6c757d";
    }
};

export default function GameFeaturingLaunchPromoStateDisplay({ state }) {
    const GameFeaturingLaunchStateTrans = useChoiceLabel("GameFeaturingLaunchState");
    switch (state) {
        case GameFeaturingLaunchState.DRAFT:
            return <Badge variant="secondary">{GameFeaturingLaunchStateTrans[state]}</Badge>;
        case GameFeaturingLaunchState.REVIEW_PASSED:
            return <Badge variant="success">{GameFeaturingLaunchStateTrans[state]}</Badge>;
        case GameFeaturingLaunchState.REJECTED:
            return <Badge variant="danger">{GameFeaturingLaunchStateTrans[state]}</Badge>;
        case GameFeaturingLaunchState.REFUSED:
            return <Badge variant="danger">{GameFeaturingLaunchStateTrans[state]}</Badge>;
        case GameFeaturingLaunchState.MARKETING_REVIEW:
            return <Badge variant="warning">{GameFeaturingLaunchStateTrans[state]}</Badge>;
        case GameFeaturingLaunchState.PROMO_LAUNCHED:
            return <Badge variant="primary">{GameFeaturingLaunchStateTrans[state]}</Badge>;
        default:
            return <></>;
    }
}
